module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-115"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ct",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-114"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-2"
    }
  }, [_c('b', [_vm._v("RAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s not much difference between transporting a prisoner and moving a load of hogs. They have to get to their destination in one piece. And that’s all, really.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was handcuffed. I felt uncomfortable and clumsy. It took all my concentration not to lose my balance as I climbed into the van. My escort, a guard with a square-shaped head, gave me a shove. It wasn’t deliberately brutal, just rough indifference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hurry up.” The only words addressed to me directly. I staggered, regained my footing, and sat down on the leatherette seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ostentatious jingling of keys. The scrape of metal on metal. The cage clanged shut; I was being moved inside a cage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d been locked up for eight years. I had grown partial to the monotonous rhythm of my days, but I had never gotten used to the bars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The van’s windows were shaded. I was seeing the outside world again for the first time, only through a dark, gray film. Still, I’d been looking forward to the trip. To see cars driving along, and trees, and teenagers riding their bikes into the wind. Maybe even a train racing us alongside the highway. Or boys on top of the overpasses yelling at the cars whizzing by below. The kind of things "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("you don’t get to see on TV because they’re too commonplace, but that make you even sicker with longing for the world outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The van set off. I was being transferred from the prison in Amersfoort to the Hopper Institute in Haarlem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hadn’t quite figured out if my transfer to the forensic psychiatric unit was something to be happy about. I’d had far too much time to think about it, the same way I had far too much time to do everything. There were days when I felt optimistic. A less strict regimen. A cell all to myself. More diversity in the daily routine. One step closer to freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then there were days when I was so angry and frustrated that I couldn’t see the plus side of anything anymore. When I just wanted to get home to my fish. I was very worried about my fish. At night I’d picture them floating belly-up. A stinking pile of "), _c('i', [_vm._v("zebrasoma, holocanthus,")]), _vm._v(" and "), _c('i', [_vm._v("amphiprion.")]), _vm._v(" I’d yell and scream until the entire cell block was awake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the nutcase again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yo, freak, shut the fuck up!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll get you tomorrow—you better watch your back, motherfucker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But in actuality, no one ever laid a finger on me, not once. It wasn’t like on those TV shows. The prisoners spent the greater part of the day just bullshitting. Every now and then a scuffle would break out over something minor, like a missing pack of cigarettes. But rape wasn’t their thing, and nobody knocked anybody’s teeth out to get better blowjobs, either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead they just made fun of me. Once, when I was in the shower, I had my clothes stolen. I sometimes had my mother’s monthly letter ripped out of my hands and read out loud in the rec room. My food was spat on almost daily. But did they ever touch me? Never.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If I wouldn’t stop screaming, the guards would make me swal"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("low a pill to calm me down. And the next day everyone would act as if nothing had happened. Sometimes they simply ignored me. Months would go by when nobody would sit next to me at mealtimes. It didn’t bother me. All I ever wanted was to be left alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The A28 and A1 highways hadn’t changed much since 2003. I pressed my nose to the window and tried to take in as much as I could: the clouds (though in prison I’d seen plenty of those), the meadows, and the water especially.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey! Stop sliming up the window,” said the guard. He was sitting next to the driver in the passenger seat and had twisted around to look at me. “Sit up straight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted to look out. I wasn’t about to let them take that away from me after all I’d been deprived of already.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A bad attitude means leg irons.” The guard turned to face the front again. “"), _c('i', [_vm._v("Asshole")]), _vm._v(".” He said it under his breath, just a barely perceptible distortion of the mouth, but I heard it. Of course he wasn’t allowed to say that sort of thing. I had read the rulebook. Too much time on your hands makes you do things like that. It said that a prisoner’s escorts had to make sure that “the transport not heighten existing stress levels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was used to being cussed at; I’d been subjected to far worse. So you could argue that the word "), _c('i', [_vm._v("asshole ")]), _vm._v("didn’t heighten my stress level, and so the guard hadn’t done anything wrong. But it was certainly open to question. I thought about writing a complaint. Though in the institution I wasn’t sure if I’d still have too much time on my hands. I was being sent there for court-ordered rehabilitation, after all—I’d be undergoing therapy so I could be reintegrated into society someday. Or so the pamphlet I’d received some weeks before my transfer said, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know who this is?” the guard asked the driver, with a jerk of the head in my direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I doubted they were allowed to talk about me in my presence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("“It was all over the papers, remember it? Freak here gets rejected by his pretty little neighbor and goes berserk. First he takes it out on the lady herself, then on her little girl, only four years old. Once he’s done hacking and slicing, he lights up, cool as a cucumber. Stubs his cigarette out on the dead kid. Can you imagine?” The guard turned back toward me. “I bet you liked that, didn’t you? Did it give you a hard-on?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pressed my nose against the window. There was an SUV driving alongside. Two little kids were belted into zebra-print car seats in the back. A boy and a girl, twins by the looks of them, about three years old. Both with curly blond hair, and the girl made me think of Anna, the little girl next door. I swallowed, to get rid of the metallic taste of blood in my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver said in a loud voice, “We "), _c('i', [_vm._v("could")]), _vm._v(" drive the car into a ditch, let the fucker drown in his cage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Accident—ooh, sorry!” The guard glanced over his shoulder to make sure I’d heard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then we’ll just sit there and have a smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A big fat joint, you mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gazed at the little girl in the SUV. It felt as if we were making eye contact, but that was impossible, of course, since I was sitting behind dark glass. Her eyes were wide open and she had long lashes. Like one of those dolls. Eyes that just stare at you and only shut when you lay it down on its back.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak1"
  }, [_vm._v("We drove up to a high wall topped with metal spikes. A gate swung open and we entered some sort of dock. For a moment we were stopped inside a fluorescent-lit concrete enclosure. Cameras zoomed in from all sides.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smile for the camera!” said the driver. Snickering. The gate lifted and we were let through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("We arrived at a sand-colored, horseshoe-shaped building. The van stopped in front of the entrance. The guard-escort got out, rattling his bunch of keys until he found the right one. Finally, the cage clicked open.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I got to my feet with difficulty. The handcuffs were tight around my wrists; my hands tingled. I almost fell on my face getting out. The guard caught me, but let go again as soon as he could, like a garbage man handling trash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He herded me ahead of him up some steps. I felt sick. Horribly sick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Automatic doors slid open. We stepped inside a small hall; on one side was a reception desk attended by a woman with hair the color of a maraschino cherry. She glanced up, then went on with her phone call uninterrupted. Who was she talking to? Was she talking about me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another guard walked up to us and began searching me without saying a word. He frisked my body with his big hands. I tried to remain calm. Tried not to let him touch me, even though he was running his hands along my crotch and the inside of my thighs. Then I was led through a metal detector.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man in a red T-shirt was waiting for me on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Welcome, Ray,” he said. “Welcome. I’m Mohammed de Vries, a social worker in the orientation unit. That’s the unit you’ll be in for the time being. You can call me Mo.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mo,” I repeated. I knew his kind. The jolly ones. The ones who pretend to be your friend at first and then drop you without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“First I’m taking you to the medical station for drug and alcohol evaluation. After that you’ll be going on to the orientation unit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t the handcuffs come off?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“Why?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?” I asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you sign for him?” The guard shoved a clipboard under the nose of the man I was allowed to call Mo. Mo printed his name and then signed. “Just like taking delivery of a FedEx package, eh, Ray?” He winked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, then, later.” The guard left through the sliding doors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Walk with me?” asked Mo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if I had a choice.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62953a00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062424815_Chapter_1.vue
// module id = 69
// module chunks = 0